import { Model, modelRegistry } from './Model';
import Store from '../wrappers/Store';
export class Pricelist extends Model {
    static entity = 'pricelists';
    id = null;
    name = null;
    enabled = true;
    created_at = null;
    updated_at = null;
    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            enabled: this.attr(true, value => !!value),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    /**
     * First pricelist whose name contains the platform source token
     * (case-insensitive). `source` is a fixed registry token like
     * 'glovo' / 'wolt'; null is returned when nothing matches so callers
     * can degrade softly.
     */
    static findByPlatformSource(source) {
        if (!source)
            return null;
        const needle = source.toLowerCase();
        return this.all().find(p => (p.name || '').toLowerCase().includes(needle)) ?? null;
    }
    /**
     * True when the pricelists module is enabled for the tenant. When it is
     * off, callers must NOT set any pricelist on an order.
     */
    static isModuleEnabled() {
        const modules = Store.get('modules');
        return !!modules?.pricelists;
    }
}
export default Pricelist;
modelRegistry.register('Pricelist', Pricelist);
//# sourceMappingURL=Pricelist.js.map